import { useQuery } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import { useSearchInput } from 'hooks/useSearchInput';

const GET_ACCOUNT_EVENTS = gql`
  query GetEventsByAccountAdmin($input: GetAccountEventsInput!) {
    getEventsByAccountAdmin(input: $input) {
      count
      results {
        id
        name
        start_date
        end_date
        fullDate
        listDates
        isMultiDay
        day
        date
        month
        year
        status
        status_color
        sale_start
        capacity
        track {
          id
          name
        }
      }
    }
  }
`;

export function useGetAccountEvents(accountId, year) {
  const { input } = useSearchInput();

  const variables = {
    input: {
      account_id: Number(accountId),
      queryString: input.queryString || '',
      page: input.page || '1',
      limit: '15',
      sort: 'asc',
    },
  };

  if (input.status) {
    variables.input.status = input.status;
  }

  if (year) {
    variables.input.year = Number(year);
  }

  const { data, loading, error, refetch } = useQuery(GET_ACCOUNT_EVENTS, {
    fetchPolicy: 'cache-and-network',
    variables,
    skip: !accountId,
  });

  return { data, loading, error, refetch };
}
